import React from "react";
import { useTranslation } from "react-i18next";
import NewsletterFormComponent from "./NewsletterFormComponent";
import styles from "./blogSubscribePrompt.module.scss";

function BlogSubscribePrompt() {
    const { t } = useTranslation("newsletterForm");
    return (
        <aside className={styles.card} aria-label={t("blogPrompt.ariaLabel")}>
            <h2 className={styles.heading}>{t("blogPrompt.heading")}</h2>
            <p className={styles.description}>
                {t("blogPrompt.description")}
            </p>
            <NewsletterFormComponent />
        </aside>
    );
}

export default BlogSubscribePrompt;
